export default function FormInput({
    label,
    name,
    type = 'text',
    value = '',
    onChange,
    error,
    required = false,
    placeholder,
    disabled = false,
    helpText,
    prefix,
    className = '',
    ...props
}) {
    const handleChange = (e) => {
        onChange(e.target.value);
    };

    const input = (
        <input
            type={type}
            id={name}
            name={name}
            className={`form-control ${error ? 'is-invalid' : ''}`}
            value={value ?? ''}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
        />
    );

    return (
        <div className={className}>
            {label && (
                <label className="form-label" htmlFor={name}>
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </label>
            )}
            {prefix ? (
                <div className="input-group">
                    <span className="input-group-text bg-white">
                        <i className={`bi ${prefix}`}></i>
                    </span>
                    {input}
                </div>
            ) : (
                input
            )}
            {error && <div className="invalid-feedback">{error}</div>}
            {helpText && <div className="form-help-text">{helpText}</div>}
        </div>
    );
}
